module.exports = {"141130100":"水头镇","141130101":"康城镇","141130102":"双池镇","141130103":"桃红坡镇","141130104":"石口镇","141130105":"回龙镇","141130202":"温泉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141130.json
// module id = 476
// module chunks = 0